import _compact from 'lodash/compact'
import _reduce from 'lodash/reduce'
import _find from 'lodash/find'
import _map from 'lodash/map'
import _keys from 'lodash/keys'
import _first from 'lodash/first'
import _last from 'lodash/last'
import _min from 'lodash/min'
import _max from 'lodash/max'

import data from '@/assets/tax-treaties.json'
import { schemeDark2 } from 'd3-scale-chromatic'
import SETTINGS from './settings'
import Vue from 'vue'

const _indicator = Symbol('indicator')
const _minValue = Symbol('minValue')
const _maxValue = Symbol('maxValue')
const _valuesHash = Symbol('valuesHash')
const _textsHash = Symbol('textsHash')
const _colorFn = Symbol('colorFn')

const taxTreaties = new class TaxTreaties {
  constructor () {
    // Common bus for non parent events
    this.bus = new Vue()
    // Current indicator
    this.indicator = this.INDICATORS[0]
    // Create a hash of texts
    this[_textsHash] = _reduce(data, (hash, { iso3, text }) => {
      hash[iso3] = text === '' ? null : text
      return hash
    }, {})
  }
  color (iso3) {
    const value = this.find(iso3)
    return value !== null && value !== undefined ? this[_colorFn](value) : '#eee'
  }
  find (iso3) {
    return this[_valuesHash][iso3]
  }
  exists (iso3) {
    return this.find(iso3) !== null
  }
  text (iso3) {
    return this[_textsHash][iso3] || null
  }
  hasAnecdote (iso3) {
    return this[_textsHash][iso3] !== null
  }
  data (iso3) {
    return _find(data, { iso3 })
  }
  previousOf (iso3) {
    const index = this.all.indexOf(iso3)
    if (index > 0) {
      return data[index - 1]
    } else {
      return null
    }
  }
  nextOf (iso3) {
    const index = this.all.indexOf(iso3)
    if (index < data.length - 1) {
      return data[index + 1]
    } else {
      return null
    }
  }
  get SCHEME () {
    return {
      'In effect': schemeDark2[0],
      'Awaits ratification': schemeDark2[1],
      'Awaits signature': schemeDark2[2],
      'In negotiation': schemeDark2[5]
    }
  }
  get INDICATORS () {
    return _keys(SETTINGS.indicators)
  }
  get VARIABLES () {
    return _keys(SETTINGS.variables)
  }
  get raw () {
    return data
  }
  get all () {
    return _map(data, 'iso3')
  }
  get iso3s () {
    return _keys(this.all)
  }
  get first () {
    return _first(data)
  }
  get last () {
    return _last(data)
  }
  get bounds () {
    return [this[_minValue], this[_maxValue]]
  }
  set indicator (indicator) {
    this[_indicator] = indicator
    // Collect all non-null values
    const values = _compact(_map(data, indicator))
    // Collect bounding values
    this[_minValue] = _min(values)
    this[_maxValue] = _max(values)
    // Create a hash of values by country
    this[_valuesHash] = _reduce(data, (hash, value) => {
      // Replace empty value by null
      hash[value.iso3] = value[indicator] !== '' ? value[indicator] : null
      return hash
    }, {})
    // Create a color scale
    this[_colorFn] = status => this.SCHEME[status]
    // Return the setted indicator
    return indicator
  }
  get indicator () {
    return this[_indicator]
  }
}()

export default taxTreaties



// WEBPACK FOOTER //
// ./src/utils/tax-treaties.js